module.exports = __webpack_public_path__ + "static/media/main.a06f485e.png";